import _extends from 'babel-runtime/helpers/extends';
import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Nav } from 'reactstrap';

import { mapListOrSingle } from './utils';

import NavigationGroup from './NavigationGroup';
import NavigationItem from './NavigationItem';

var NAV_PULL_RIGHT_CLASS = 'd-flex justify-content-end';
var NAV_SECONDARY_CLASS = 'navbar-sidenav';

var NavigationList = function (_PureComponent) {
  _inherits(NavigationList, _PureComponent);

  function NavigationList(props) {
    _classCallCheck(this, NavigationList);

    return _possibleConstructorReturn(this, (NavigationList.__proto__ || Object.getPrototypeOf(NavigationList)).call(this, props));
  }

  _createClass(NavigationList, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          pullRight = _props.pullRight,
          isPrimary = _props.isPrimary,
          className = _props.className,
          items = _props.items,
          collapsed = _props.collapsed,
          onGroupClick = _props.onGroupClick,
          openGroupId = _props.openGroupId,
          otherProps = _objectWithoutProperties(_props, ['pullRight', 'isPrimary', 'className', 'items', 'collapsed', 'onGroupClick', 'openGroupId']);

      var itemProps = _extends({}, otherProps, {
        collapsed: collapsed,
        isPrimary: isPrimary
      });

      var groupProps = _extends({}, itemProps, {
        openGroupId: openGroupId,
        onGroupClick: onGroupClick
      });

      var containerClasses = [];
      if (isPrimary && pullRight) {
        containerClasses.push(NAV_PULL_RIGHT_CLASS);
      }
      if (!isPrimary) {
        containerClasses.push(NAV_SECONDARY_CLASS);
      }
      if (className) {
        containerClasses.push(className);
      }

      var containerClass = containerClasses.length ? containerClasses.join(' ') : null;

      var navItems = mapListOrSingle(items, function (item) {
        return item.items !== void 0 ? React.createElement(NavigationGroup, _extends({}, groupProps, { key: item.id, item: item })) : React.createElement(NavigationItem, _extends({}, itemProps, { key: item.id, item: item }));
      });

      return navItems.length ? React.createElement(
        Nav,
        { navbar: true, className: containerClass },
        navItems
      ) : false;
    }
  }]);

  return NavigationList;
}(PureComponent);

NavigationList.propTypes = {
  pullRight: PropTypes.bool,
  isPrimary: PropTypes.bool,
  isDropdown: PropTypes.bool,
  items: PropTypes.array,
  collapsed: PropTypes.bool,
  onItemClick: PropTypes.func,
  onGroupClick: PropTypes.func,
  openGroupId: PropTypes.any,
  isItemActive: PropTypes.func,
  formatItemPath: PropTypes.func
};
NavigationList.defaultProps = {
  pullRight: false,
  onItemClick: function onItemClick() {},
  onGroupClick: function onGroupClick() {}
};
export default NavigationList;